import {
  SET_DATASET_ACTION,
  SET_SIMULATION_SPEED,
  SET_SMOOTH_ARRAY,
  SET_TICK_DURATION,
  SET_DRAG_DATA_ACTION,
  SET_CHART_DOTS,
  SET_TICK,
  RESET_APP,
  GET_STEPS_REQUEST,
  SET_RANDOM_ORDERS,
  SET_ORDERS_PARAMS,
  SET_ORDER_LIMITS, SET_ACTIVE_STREAM, PLACE_ORDER,
} from "./consts";

export const setDatasetAction = (payload) => ({
  type: SET_DATASET_ACTION,
  payload,
});

export const setSimulationSpeedAction = (payload) => ({
  type: SET_SIMULATION_SPEED,
  payload,
});

export const setSmoothArrayAction = (payload) => ({
  type: SET_SMOOTH_ARRAY,
  payload,
});

export const setTickDuration = (payload) => ({
  type: SET_TICK_DURATION,
  payload,
});

export const setDragData = (payload) => ({
  type: SET_DRAG_DATA_ACTION,
  payload,
});

export const setChartDots = (payload) => ({
  type: SET_CHART_DOTS,
  payload,
});

export const setTick = (payload) => ({
  type: SET_TICK,
  payload,
});

export const resetApp = () => ({
  type: RESET_APP,
});

export const getSteps = (payload) => ({
  type: GET_STEPS_REQUEST,
  payload,
});

export const setRandomOrders = (payload) => ({
  type: SET_RANDOM_ORDERS,
  payload,
});

export const setOrdersParams = (payload) => ({
  type: SET_ORDERS_PARAMS,
  payload,
});

export const setOrderLimits = (payload) => ({
  type: SET_ORDER_LIMITS,
  payload,
});


export const setActiveStream = (payload) => ({
  type: SET_ACTIVE_STREAM,
  payload,
});

export const placeOrder = (payload) => ({
  type: PLACE_ORDER,
  payload,
});
